import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { limitStringLength } from '../../helpers/util';
import { portionSwitch, reversePortionSwitch } from '../../masks';
import HeartGold from '../../svg/HeartGold.js';
import HeartGoldOutline from '../../svg/HeartGoldOutline.js';
import PencilGold from '../../svg/PencilGold.js';
import MeasuringCup from '../../svg/MeasuringCup.js';

class MenuSelectionCardNew extends React.Component {
  state = {
    height: 0,
    isFavorite: false,
    dish: {},
    menuSelection: {},
    isOnboarding: false
  };

  render() {
    const { isOnboarding } = this.state;
    const {
      className,
      displayOnly = false,
      activeClassName = 'menu-selection-card-new--active',
      dish = {},
      menuSelection = {}
    } = this.props;
    const { quantity = 0, notes = '', portion = '' } = menuSelection;

    const isActive = quantity > 0 && !displayOnly;
    const classNames = ['menu-selection-card-new', className];
    if (!displayOnly) classNames.push('menu-selection-card-new--clickable');
    if (isActive) classNames.push(activeClassName);
    if (isOnboarding && !notes && !portion)
      classNames.push('menu-selection-card-new--onboarding-simple');

    return (
      <div className={classNames.join(' ')} onClick={this.toggle}>
        <div className="menu-selection-card-new__heading-wrap">
          <h4 className="menu-selection-card-new__name">{dish.name}</h4>
        </div>
        {this.renderDietaryPreferences()}
        <div className="menu-selection-card-new__ingredients-wrap">
          {ReactHtmlParser(dish.public_ingredients)}
        </div>
        {!isOnboarding && this.renderFavoriteButton()}
        {!displayOnly && this.renderCustomizeButton()}
        {quantity > 0 && this.renderPortion()}

        {notes && this.renderNotes(notes)}
      </div>
    );
  }

  getPortion = () => {
    const { portion = '' } = this.props.menuSelection;
    const { portion_size } = this.props.client;

    // selection portion will default to client's portion_size
    return portion ? portion : `${portionSwitch(portion_size)}.0`; // format numbers as string with decimal.  e.g. "1.0"
  };

  toggle = e => {
    const { displayOnly, menuSelection = {} } = this.props;
    const { quantity = 0 } = menuSelection;
    const { isOnboarding } = this.state;

    // If card is not for display only
    if (!displayOnly) {
      if (quantity > 1) {
        return;
      }

      let menu_selection = {
        ...menuSelection,
        quantity: quantity === 0 ? 1 : 0,
        notes: '',
        portion: isOnboarding ? null : this.getPortion()
      };

      // Remove portion key if unselecting menu selection
      if (quantity === 1) delete menu_selection.portion;

      this.props.updateMenuSelection(this.props.index, menu_selection);
    }
  };

  renderPortion = () => {
    const { client = {}, menuSelection } = this.props;
    const { portion_size } = client;
    const { portion } = menuSelection;
    const { isOnboarding } = this.state;

    if (!portion) return;

    // change format from strings of numbers to name. e.g. "2.0" -> "medium"
    const menuPortion = reversePortionSwitch(portion) || portion_size;

    const classes = isOnboarding
      ? 'menu-selection-card-new__portion--onboarding'
      : 'menu-selection-card-new__portion';

    return portion_size !== menuPortion ? (
      <div className={classes}>
        <MeasuringCup />
        <p className="menu-selection-card-new__portion-name">{menuPortion}</p>
      </div>
    ) : (
      ''
    );
  };

  renderDietaryPreferences = () => {
    const { dish = {} } = this.state;
    const { dietary_preference_tags = [] } = dish;
    return (
      dietary_preference_tags.length > 0 && (
        <div>
          {dietary_preference_tags.map(tag => (
            <span
              className="menu-selection-card-new__dietary-preferences"
              key={tag.abbreviation}
            >
              {tag.abbreviation}
            </span>
          ))}
        </div>
      )
    );
  };

  renderCustomizeButton = () => {
    const { isOnboarding } = this.state;
    const classes = isOnboarding
      ? 'menu-selection-card-new__customize--onboarding'
      : 'menu-selection-card-new__customize';

    return (
      <button className={classes} onClick={e => this.handleClickCustomize(e)}>
        <PencilGold />
      </button>
    );
  };

  handleClickCustomize = e => {
    const {
      handleCustomizeDish,
      index,
      updateMenuSelection,
      menuSelection
    } = this.props;

    // Clicking pencil makes sure quantity is 1.  (Does not toggle)
    const menu_selection = {
      ...menuSelection,
      quantity: 1
    };
    updateMenuSelection(this.props.index, menu_selection);

    // open customize screen
    handleCustomizeDish(e, menu_selection, index);
  };

  renderFavoriteButton = () => {
    const { dish = {}, favoritedDishes = [] } = this.props;

    const isFavorite =
      favoritedDishes.includes(dish.id) ||
      favoritedDishes.includes(dish.parent_dish_id);

    return (
      <button
        onClick={this.toggleFavoriteDish}
        className="menu-selection-card-new__favorite-button"
        aria-label="toggle favorite status on dish"
      >
        {isFavorite ? <HeartGold /> : <HeartGoldOutline />}
      </button>
    );
  };

  toggleFavoriteDish = e => {
    const { favoriteDish, unfavoriteDish, dish, favoritedDishes } = this.props;

    const isFavorite =
      favoritedDishes.includes(dish.id) ||
      favoritedDishes.includes(dish.parent_dish_id);

    // prevent menu selection when just clicking on heart button
    e.stopPropagation();

    // if dish has a parent id, use for favoriting
    const id = dish.parent_dish_id ? dish.parent_dish_id : dish.id;

    if (isFavorite) {
      // Remove favorite
      unfavoriteDish(id);
    } else {
      // Add favorite
      favoriteDish(id);
    }
  };

  renderNotes = (notes, limit = 100) => (
    <p className="menu-selection-card-new__notes">
      {limitStringLength(notes, limit)}
    </p>
  );

  componentDidUpdate(prevProps) {
    const { menuSelection } = this.props;

    if (prevProps.menuSelection !== menuSelection)
      this.setState({ menuSelection });
  }

  componentDidMount() {
    const { dish = {}, menuSelection = {} } = this.props;

    const isOnboarding = window.location.pathname.includes('new-client');

    this.setState({
      dish,
      menuSelection,
      isOnboarding
    });
  }
}

export default MenuSelectionCardNew;



// WEBPACK FOOTER //
// ./src/components/new/MenuSelectionCardNew.js